import React from "react";
import { formatPrice } from "utils";
import { FiInfo } from "react-icons/fi";

export default function FormalitiesTemplateItem({
  tpl,
  onSelect,
  onShowPricing
}) {
  return (
    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <div className="formality-template-card">

        <div className="formality-template-card-header py-3 px-3">
          <div className="ftName fw-bold">{tpl.ftName}</div>
        </div>

        <div className="formality-template-card-body d-none px-3">
          <div className="small text-center">{tpl.ftSummary}</div>
        </div>

        <div className="formality-template-card-bottom d-flex justify-content-between align-items-center py-3 px-3">

          <div className="ftTotalPriceIT">
            {tpl.pricing?.fpTotalPriceIT > 0 ? (
              <span className="d-flex align-items-center gap-2 text-nowrap small">
                <span>{formatPrice(tpl.pricing.fpTotalPriceIT)}€ TTC</span>

                <FiInfo
                  size={16}
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onShowPricing(tpl.pricing);
                  }}
                  title="Détail du prix"
                />
              </span>
            ) : (
              <span />
            )}
          </div>

          <button
            className="btn btn-primary rounded-pill px-4 py-1"
            onClick={(e) => {
              e.stopPropagation();
              onSelect(tpl);
            }}
          >
            Démarrer
          </button>

        </div>

      </div>
    </div>
  );
}